import { createAsyncThunk } from '@reduxjs/toolkit'
import Branding from './branding-model'
import {
  delete_branding,
  load_brandings,
  store_branding,
} from './branding-service'

export const LoadBrandingsAsync = createAsyncThunk<any, any>(
  'composer/load/branding',
  async (params: { uid: string }) => {
    return await load_brandings(params)
  },
)

export const CreateBrandingAsync = createAsyncThunk<any, any>(
  'composer/create/branding',
  async (params: Branding) => {
    return await store_branding(params)
  },
)

export const DeleteBrandingAsync = createAsyncThunk<any, any>(
  'composer/delete/branding',
  async (params) => {
    return await delete_branding(params)
  },
)
